import { Injectable, ViewChild } from "@angular/core";
import { Component, OnInit, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { BehaviorSubject, Observable } from "rxjs";

import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { NzUploadChangeParam } from "ng-zorro-antd/upload";

import { HttpClient, HttpHeaders } from "@angular/common/http";

import { User } from "@app/_models";
import { Files } from "@app/_models";
import { UserService, AuthenticationService } from "@app/_services";
import { ApiBackendService } from "@app/_services/api-backend.service";

@Component({
  selector: "app-pay",
  templateUrl: "./pay.component.html",
  styleUrls: ["./pay.component.css"],
})
@Injectable({ providedIn: "root" })
export class PayComponent implements OnInit {
  users: User[];
  apiUrl = null;
  bodyData = null;
  loading = false;
  loadingPage = true;
  path = null;
  file = null;
  userCreated = null;
  isSpinning = false;
  isSpinningReccuring = false;
  files: Observable<Files[]>;
  error = null;
  errorMessage = null;
  currentUser = JSON.parse(localStorage.getItem("currentUser"));
  filesList: any[] = [];
  progress = null;
  fileDate = null;
  userCredit = null;
  tranzactionType: String;
  public mobilpayData: any = [];
  fileTypeError = 0;
  reccurenceStatus: string = "";
  reccurenceMessage: string = "";

  @ViewChild("form") form;
  constructor(private userService: UserService, private storage: AngularFireStorage, private route: ActivatedRoute, private http: HttpClient, private router: Router, private authenticationService: AuthenticationService, private modal: NzModalService, private msg: NzMessageService, private viewContainerRef: ViewContainerRef, public apiBackendService: ApiBackendService) {
    // redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      // this.router.navigate(['/authentification']);
    }
    this.apiUrl = this.authenticationService.apiUrl;
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.getUser()
      .pipe()
      .subscribe((res) => {
        // console.log(res.body["credit"]);
        this.userCredit = res.body["credit"];
        this.loadingPage = false;
      });
    this.apiBackendService
      .getUserReccurence(this.currentUser.id)
      .pipe()
      .subscribe((res: any) => {
        this.reccurenceStatus = res.body.status;
        this.reccurenceMessage = res.body.message;
        this.isSpinningReccuring = true;
      });
  }

  getUser() {
    return this.http.get<User[]>(this.apiUrl + "/user/" + this.currentUser.id, {
      observe: "response",
    });
  }

  tranzactionTypeChanged(type: string) {
    this.tranzactionType = type;
    console.log("tranzaction changed", this.tranzactionType);
    if (this.tranzactionType === "recurring") {
      // Afișează un modal de confirmare
      this.modal.confirm({
        nzTitle: "Confirmare plată recurentă",
        nzContent: "Ești sigur că dorești să activezi un abonament recurent de 100 RON pe lună?",
        nzOnOk: () => {
          this.isSpinning = true;
          this.apiBackendService
            .getMobilPayData("recurring")
            .pipe()
            .subscribe((res) => {
              this.mobilpayData = res.body;
              this.isSpinning = false;
              this.handlePaymentRedirect();
            });
        },
      });
    } else {
      this.apiBackendService
        .getMobilPayData(this.tranzactionType)
        .pipe()
        .subscribe((res) => {
          this.mobilpayData = res.body;
          this.handlePaymentRedirect();
        });
    }
  }

  handlePaymentRedirect() {
    console.log("handlePaymentRedirect called with:", this.mobilpayData);
    // Check if this is v2 API response (empty env_key and data)
    if ((!this.mobilpayData.env_key || this.mobilpayData.env_key === '') &&
        (!this.mobilpayData.data || this.mobilpayData.data === '') &&
        this.mobilpayData.url) {
      // V2 API: Direct redirect to payment URL
      console.log("V2 API: Redirecting to", this.mobilpayData.url);
      window.location.href = this.mobilpayData.url;
    } else if (this.mobilpayData.env_key && this.mobilpayData.data) {
      // V1 API: Submit form with env_key and data
      setTimeout(() => {
        if (this.form && this.form.nativeElement) {
          this.form.nativeElement.submit();
        } else {
          console.error("Form element not found");
          this.msg.error("Eroare la inițializarea plății - formular negăsit");
        }
      });
    } else {
      console.error("Invalid payment response", this.mobilpayData);
      this.msg.error("Eroare la inițializarea plății");
    }
  }
}
